import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Workshop, WorkshopStatus } from './workshop.constants';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Injectable({
  providedIn: 'root',
})
export class WorkshopService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  createWorkshop(workshopData: Workshop): Observable<any> {
    return this.http.post(
      `/api/workshop/save`,
      workshopData,
      this.commonService.getHeaders()
    );
  }

  getWorkshopList(courseTypeId: number): Observable<any> {
    return this.http.get(
      `/api/workshop/get?courseTypeId=${courseTypeId}`,
      this.commonService.getHeaders()
    );
  }

  getWorkshopById(workshopId: string): Observable<any> {
    return this.http.get(
      `/api/workshop/get/${workshopId}`,
      this.commonService.getHeaders()
    );
  }

  updateWorkshop(workshopData: Workshop, workshopId: string): Observable<any> {
    return this.http.put(
      `/api/workshop/update/${workshopId}`,
      workshopData,
      this.commonService.getHeaders()
    );
  }

  assignWorkshop(
    workshopId: string,
    studentIds: string,
    dueDate: string
  ): Observable<any> {
    return this.http.post(
      `/api/workshop/assign/${workshopId}?studentsList=${studentIds}&dueDate=${dueDate}`,
      null,
      this.commonService.getHeaders()
    );
  }

  getWorkshopsByStudentId(studentId: string, date?: string): Observable<any> {
    return this.http.get(
      `/api/workshop/student?student_id=${studentId}&completedBy=${date}`,
      this.commonService.getHeaders()
    );
  }

  getWorkshopQuestions(
    workshopId: string,
    questionIds: string,
    studentId: number
  ) {
    return this.http.get(
      `/api/studentWorkshopAttemptedQuestions/get/${workshopId}?questionIds=${questionIds}&studentId=${studentId}`,
      this.commonService.getHeaders()
    );
  }

  submitAnswer(data: any): Observable<any> {
    return this.http.post(
      `/api/studentWorkshopAttemptedQuestions/save`,
      data,
      this.commonService.getHeaders()
    );
  }
  getWorkshopForStudent(
    workshopId: string,
    studentId: number
  ): Observable<any> {
    return this.http.get(
      `/api/workshop/student/get/${workshopId}?studentId=${studentId}`,
      this.commonService.getHeaders()
    );
  }

  resetWorkshop(workshopId: string): Observable<any> {
    return this.http.post(
      `/api/studentWorkshopAttemptedQuestions/reset/${workshopId}`,
      {},
      this.commonService.getHeaders()
    );
  }

  saveWorkshopStatus(workshopStatus: WorkshopStatus): Observable<any> {
    return this.http.post(
      `/api/studentWorkshopProgress/save`,
      workshopStatus,
      this.commonService.getHeaders()
    );
  }

  updateWorkshopStatus(
    status: number,
    workshopId: string,
    slpId: string
  ): Observable<any> {
    return this.http.put(
      `/api/studentWorkshopProgress/update/${slpId}`,
      { status, workshopId },
      this.commonService.getHeaders()
    );
  }
}
